import ApiService from "../ApiService";
const { REACT_APP_REST_ENDPOINT } = process.env;

export default class SediService {
  static getAllSedi = () => {
    let url = `${REACT_APP_REST_ENDPOINT}/sedi`;
    return ApiService.getRudeRequest(url);
  };

  static getSediByParams = (params) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sedi/find`;
      ApiService.postRudeRequest(resolve, reject, url, params);
    });
  };

  static createSede = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sedi/create`;
      ApiService.postRequest(resolve, reject, url, data);
    });
  };

  static deleteSede = (id) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sedi/delete`;
      ApiService.delete(resolve, reject, url, id);
    });
  };

  static updateSede = (data) => {
    return new Promise((resolve, reject) => {
      const url = `${REACT_APP_REST_ENDPOINT}/sedi/update`;
      ApiService.putRequest(resolve, reject, url, data);
    });
  };
}